module.exports = __webpack_public_path__ + "img/approval-3.2d444b86.png";